module.exports = __webpack_public_path__ + "static/media/world-map.a38a7d5b.webp";